import { apiClient } from './api.service';

export interface FetchJuniperDataRequest {
  operationalBillId: number;
  trrBillId?: number;
  includePaymentLink?: boolean;
}

export interface JuniperDataResult {
  operational_bill?: any;
  trust_request_bill?: any;
  matter?: any;
  trust?: {
    bank_transactions: any[];
    trustBalance?: {
      total: number;
      accounts: Array<{ accountId: string; balance: number; accountName?: string }>;
      fetchedAt: string;
    };
  };
  clioPaymentLinkId?: string;
  clioPaymentLinkUrl?: string;
  clio_payment_link?: Record<string, unknown>;
  matterWIPAmount?: number;
  last_juniper_transaction?: any;
  outstanding_bills?: any[];
  minimumThreshold?: number;
  trustBalance?: number;
  outstandingBalance?: number;
  calculatedTrustAmount?: number;
  [key: string]: unknown;
}

class JuniperDataService {
  async fetchJuniperData(tenantId: string, request: FetchJuniperDataRequest): Promise<JuniperDataResult> {
    const response = await apiClient.post<JuniperDataResult>(
      `/admin/tenants/${encodeURIComponent(tenantId)}/clio/data`,
      request
    );
    return response.data;
  }
}

export const juniperDataService = new JuniperDataService();
